<template>
  <div style="position: relative">
      <div v-if="labelText" class="labels" style="z-index: 2;">
        <span class="labels-discount">{{ labelText }}</span>
      </div>
    <swiper
        :style="{'--swiper-navigation-color': '#fff','--swiper-pagination-color': '#fff'}"
        :spaceBetween="10"
        :loop="true"
        :navigation="true"
        :thumbs="{ swiper: thumbsSwiper }"
        class="prod__slider"
    >
      <swiper-slide v-for="image in images" :key="`b${image.big}`">
        <img :src="image.big" :alt="product.name" width="560" height="560" loading="lazy" decoding="async"/>
      </swiper-slide>
    </swiper>
    <swiper
        @swiper="setThumbsSwiper"
        :spaceBetween="13"
        :slidesPerView="5"
        :watchSlidesVisibility="true"
        :watchSlidesProgress="true"
        class="prod__gallery"
    >
      <swiper-slide v-for="image in images" :key="`m${image.big}`">
        <img :src="image.big" :alt="product.name" width="560" height="560" loading="lazy" decoding="async"/>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import {computed, ref, toRefs} from "vue";
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/swiper.scss';
import "swiper/components/thumbs/thumbs.min.css"
import SwiperCore, {
  Navigation, Thumbs
} from 'swiper/core';

// install Swiper modules
SwiperCore.use([Navigation, Thumbs]);

export default {
  name: "ProductModalImages",
  props: {
    product: {},
    color_id: {},
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props) {
    const {product} = toRefs(props)
    const color = ref(props.color_id)

    const images = computed(() => {
      return product.value.images[color.value]
    })

    const thumbsSwiper = ref(null);
    const setThumbsSwiper = (swiper) => {
      thumbsSwiper.value = swiper;
    }

    window.addEventListener('colorSelected', (e) => {
      color.value = e.detail.color_id
    })

    const labelText = computed(() => {
      return product.value.discount_text
    })

    return {
      labelText,
      color,
      product,
      images,
      thumbsSwiper,
      setThumbsSwiper,
    }
  }
}
</script>

<style scoped lang="scss">

</style>
